import { AbstractBoolProperty } from './AbstractBoolProperty'

export class TestHotelFlag extends AbstractBoolProperty {
  KEY: string = 'testHotelFlag'
}
